import { Page } from "../../types";

interface SavePageRequest {
  page: Page;
  password: string;
}

interface PageResponse {
  pages: Page[];
}

const host = "https://api.lightsart.de";
//const host = "http://localhost:8080";

const savePage = async (data: SavePageRequest): Promise<number> => {
  const json = JSON.stringify(data);

  const response = await fetch(`${host}/api/data/savePage`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Headers": "*",
    },
    body: json,
  });
  return response.status;
};

const getPages = async (): Promise<PageResponse> => {
  const response = await fetch(`${host}/api/data/getPages`, {
    method: "GET",
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Headers": "*",
      "Content-Type": "application/json",
    },
  });
  const res: PageResponse = await response.json();

  // sort sections in pages
  // sort pictures in sections nad texts in sections

  const a = {
    pages: res.pages.map((page) => {
      return {
        ...page,
        sections: page.sections.map((section) => {
          return {
            ...section,
            pictures: section.pictures?.sort(orderByPosition),
            texts: section.texts?.sort(orderByPosition),
          };
        }),
      };
    }),
  };

  a.pages.forEach((page) => {
    page.sections.sort(orderByPosition);
  });

  return a;
};

const orderByPosition = (a: any, b: any) => {
  if (a.position < b.position) {
    return -1;
  }
  if (a.position > b.position) {
    return 1;
  }
  return 0;
};

export { savePage, getPages };
